import { useState } from "react";
import AudioPlayer from "./AudioPlayer";
import { SONG_LIST } from "./SongList";
export default function DisplaySongList() {
  const [currentSong, setCurrentSong] = useState(null);

  const songList = SONG_LIST;

  function handleChangeSong(songId = 0) {
    {
      setCurrentSong(songId);

      songList.map((song) => {
        song.id === songId ? (song.play = 1) : (song.play = 0);
      });
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-xs-12">
          <h1>Samples</h1>
        </div>
      </div>
      <div className="row">
        {songList.map((song) => (
          <div
            className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-xs-12"
            key={song.id}
          >
            <AudioPlayer
              audioSrc={song}
              palyedSong={handleChangeSong}
              playSong={song.play}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
